import { createSlice } from "@reduxjs/toolkit";

// Define the interface for cart items
export interface CartItem {
  id: number;
  name: string;
  attributes: {
    event_fee: number;
    [key: string]: any; // Allows for additional properties within attributes
  };
  event_fee: number;
  price: number;
  inCart: number;
  maximum_entry: number;
  is_vendor_event: boolean;
  isCombo: boolean;
  // Add other properties as needed
}

// Define the interface for the cart state
interface CartState {
  items: CartItem[];
}

// Initial state
const initialState: CartState = {
  items: [],
};

// Create the slice
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    // Action to add an item to the cart
    addItem: (state, action) => {
      const existingItem = state.items.find(
        (item) => item.id === action.payload.data.id,
      );

      if (!action.payload.persist) {
        localStorage.removeItem("promoCodeData");
        localStorage.removeItem("formData");
      }

      if (existingItem) {
        // If item exists, increment the inCart variable
        existingItem.inCart += 1;
      } else {
        // Otherwise, add the new item to the cart with inCart set to 1
        state.items.unshift({ ...action.payload.data, inCart: 1 });
        // state.items.push({ ...action.payload.data, inCart: 1 });
        // state.items.reverse()
      }
    },

    // Action to remove an item from the cart by ID
    removeItem: (state, action) => {
      const index = state.items.findIndex(
        (item) => item.id === action.payload.data.id,
      );

      if (!action.payload.persist) {
        localStorage.removeItem("promoCodeData");
        localStorage.removeItem("formData");
      }

      if (index !== -1) {
        state.items[index].inCart -= 1;

        // Remove item from cart if inCart reaches 0
        if (state.items[index].inCart === 0) {
          state.items.splice(index, 1);
        }
      }
    },
    // Action to clear the cart
    clearCart: (state) => {
      state.items = [];
    },
    removeAndAddItems: (state, action) => {
      state.items = [];
      localStorage.removeItem("promoCodeData");
      localStorage.removeItem("formData");
      state.items.unshift({ ...action.payload.data, inCart: 1 });
    },
  },
});

// Export the actions
export const { addItem, removeItem, clearCart, removeAndAddItems } =
  cartSlice.actions;

// Selector to get the cart items from the state
export const selectCartItems = (state: { cart: CartState }) => state.cart.items;

export default cartSlice.reducer;
